import './css/main.css';

import { start as startApp } from '@fasstech/oip-starter-utils/app';
import { App } from './App';
import { ProcessFragment } from './graphql/fragments/process.js';
import { useCustomHandlers } from './hooks';

(async () => {
  await startApp({
    useCustomHandlers,
    app: App,
    processFragment: ProcessFragment,
    ctxPolicy: 'shadow-crm',
    redirectOnError: !(window.__REDIRECT_ON_ERROR__ === 'false')
  });
})();
